import { ENetworkEventBothWays } from './ENetworkEventBothWays';

export const ENUM__network_event_client_to_server = {
  ...{
    /*
     * ADMIN
     */

    /*
     * BILLING
     */
    BILLING_STRIPE_CHECKOUT_SESSION_CREATE: '/billing/stripe/checkout_session/create',

    /*
     * COLLECTION IMAGES
     */
    COLLECTION_GET_SHARED_BY_ID: '/collection/shared/get',

    COLLECTION_CREATE: '/collection/create',
    COLLECTION_UPDATE_VISIBILITY: '/collection/update/visibility',
    COLLECTION_UPDATE_NAME: '/collection/update/name',

    //CELLS
    COLLECTION__IMAGE_ADD: '/collection/image/add',
    COLLECTION__IMAGE_DELETE: '/collection/image/delete',

    COLLECTION_GET_RECENT_IMAGES_URLS: '/collection/recent_images_urls/get',

    /*
     * GENERATION
     */

    GENERATION_CREATE: '/generation/create',
    GENERATION_CREATE_FOR_FIELD_CONSUMER: '/generation/create_for_field_consumer',
    GENERATION_CONSUME_CONTENT: '/generation/consume_content',
    GENERATION_UPDATE_NAME: '/generation/update/name',

    GENERATION_UPDATE_GRAPH: '/generation/update/graph',
    GENERATION_UPDATE_TOOL: '/generation/update/tool',
    GENERATION_UPDATE_TOOL_NAME: '/generation/update/tool/name',

    GENERATION_DURATION_ADJUSTING_ADD: '/generation/duration_adjusting/add',

    GENERATION_START: `/generation/start`,
    GENERATION_START_WITH_NEW_SEEDS: `/generation/start_with_new_seeds`,
    GENERATION_STOP: `/generation/stop`,

    GENERATION_UPDATE_STATUS_LOCK: `/generation/update/status/lock`,
    GENERATION_UPDATE_VISIBILITY: `/generation/update/visibility`,
    GENERATION_FIELDS_STORE_CLEAN: `/generation/fields_store/clean`,

    /*
     * GENERATION PRICE
     */

    GENERATION_PRICE_GET_GENERATION_PRICE_BY_HASH: '/generation_price/get_generation_price_by_hash',
    /*
     * GRID2D
     */
    GRID2D_GET_USER_TASK: '/grid2d/get/user_task',
    GRID2D_GET_GENERATION: '/grid2d/get/generation',
    GRID2D_GET_SEARCH: '/grid2d/get/search',
    GRID2D_GET_BY_ENTITY_TYPE_AND_ID: '/grid2d/get/by_entity_type_and_id',
    GRID2D_DOWNLOAD_IMAGES: '/grid2d/download/images',

    GRID2D_CHUNK_LOAD_CELLS: '/grid2d_chunk/load_cells',
    /*
     * IMAGE
     */
    IMAGES_AI_DESCRIPTION_CREATE: '/images/ai_description/create',
    IMAGES_AI_DESCRIPTION_TRANSLATE: '/images/ai_description/translate',

    IMAGES__USE_IN_NON_CUSTOM_COLLECTION: `/images/use_in/non_custom_collection`,
    IMAGES_FILE_DATA_UPLOAD_TO_WORKSPACE: `/images/file_data/upload/to_workspace`,

    IMAGE_ASSET_SEGMENT: `/image_asset/segment`,
    IMAGE_ASSET_FILTER: `/image_asset/filter`,

    IMAGES_LOAD_BY_HASH_CONTENT: `/images/load/by_hash_content`,

    /*
     * ML ASSET
     */
    ML_ASSET_RENT: '/ml_asset/rent',

    ML_ASSET_GET_BY_ID: '/ml_asset/get_by_id',

    ML_ASSET_LOAD_PAGE_ITEMS: '/ml_asset/load/page_items',
    ML_ASSET_RESERVATION_CREATE: '/ml_asset_reservation/create',

    /*
     * SEARCH
     */
    SEARCH_CREATE: '/search/create',
    SEARCH_UPDATE: '/search/update',

    SEARCH_GET_SHARED_BY_ID: '/search/shared/get',

    SEARCH_TOKEN_ADD: '/search/token/add',
    SEARCH_TOKENS_DELETE: '/search/tokens/delete',
    SEARCH_TOKENS_UPDATE_VISIBILITY: '/search/tokens/update/visibility',

    /*
     * USER
     */
    USER_AUTH_LOGIN_WITH_EMAIL_AND_PASSWORD: '/user/auth/login_with_email_and_password',
    USER_AUTH_LOGIN_WITH_MAGIC_LINK_TOKEN: '/user/auth/login_with_magic_link_token',
    USER_AUTH_LOGIN_WITH_TOKEN: '/user/auth/login_with_token',

    USER_AUTH_MAGIC_LINK_GENERATE: '/user/auth/magic_link/generate',
    USER_AUTH_VERIFY_EMAIL_AND_LOGIN: '/user/auth/verify_email_and_login',

    USER_AUTH_LOGOUT: '/user/auth/logout',

    USER_AUTH_PROVIDER_GOOGLE_UNLINK: '/auth/provider/google/unlink',
    USER_AUTH_PROVIDER_MICROSOFT_UNLINK: '/auth/provider/microsoft/unlink',
    USER_AUTH_PROVIDER_GITHUB_UNLINK: '/auth/provider/github/unlink',
    USER_AUTH_PROVIDER_DISCORD_UNLINK: '/auth/provider/discord/unlink',
    USER_AUTH_PROVIDER_FACEBOOK_UNLINK: '/auth/provider/facebook/unlink',

    USER_SETTINGS_UPDATE: '/user/settings/update',

    USER_SETTINGS_UPDATE_USER_NAME: '/user/settings/update/name',
    USER_SETTINGS_UPDATE_USER_AVATAR: '/user/settings/update/avatar',
    USER_SETTINGS_UPDATE_USER_PASSWORD: '/user/settings/update/password',

    USER_SUPPORT_MESSAGE_CREATE: '/user/support_message/create',

    USER_TUTORIAL_PROGRESS_UPDATE: '/user/tutorial/progress/update',

    /*
     * USER TASK
     */

    USER_TASK_CREATE: '/user_task/create',
    USER_TASK_UPDATE_VISIBILITY: '/user_task/update/visibility',
    USER_TASK_UPDATE_NAME: '/user_task/update/name',
    USER_TASK_DUPLICATE: '/user_task/duplicate',

    USER_TASK_GET_SHARED_BY_GENERATION_ID: `/user_task/shared/get/`,

    USER_TASK_LOAD_GENERATIONS_BY_TASK_ID: '/user_task/load_generations/by_task_id',
    USER_TASK_LOAD_GENERATIONS_BY_GENERATION_ID: '/user_task/load_generations/by_generation_id',

    USER_TASK_REFERENCE_IMAGE_DELETE: '/user_task/reference/image/delete',

    /*
     * VISION
     */

    /*
     * WORD
     */

    WORDS_TRANSLATE_FROM_ENGLISH_WITH_CONTEXT: '/words/translate_from_english_with_context',
    WORDS_TRANSLATE_FROM_ENGLISH: '/words/translate_from_english',

    /*
     * WORD RELATED
     */
    WORD_WITH_WORDS_RELATED_CREATE: '/word/with/related/create',
    WORD_WITH_WORDS_RELATED_GET: '/word/with/related/get',

    /*
     * WORKSPACE
     */

    WORKSPACE_CREATE: '/workspace/create',
    WORKSPACE_UPDATE: '/workspace/update/',
    WORKSPACE_CHILD_ENTITY_DELETE: '/workspace/entity/delete',
    WORKSPACE_CHILD_ENTITY_UPDATE_SHARE_STATUS: '/workspace/entity/update/share_status',
    WORKSPACE_CHILD_ENTITY_UPDATE_VIEWER_STATUS: '/workspace/entity/update/viewer_status',
    WORKSPACE_CHILD_ENTITY_VIEWER_ACTION: '/workspace/entity/viewer_action',

    WORKSPACE_UPDATE_AVATAR: '/workspace/update/avatar',
    WORKSPACE_USER_UPDATE_PERMISSIONS: '/workspace/user/update/permissions',
    WORKSPACE_TRANSER_OWNERSHIP_CREATE: '/workspace/transfer/ownership/create',
    WORKSPACE_TRANSER_OWNERSHIP_DELETE: '/workspace/transfer/ownership/delete',
    WORKSPACE_TRANSER_OWNERSHIP_REPLY: '/workspace/transfer/ownership/reply',

    WORKSPACE_USER_INVITATION_CREATE: '/workspace/user_invitation/create',
    WORKSPACE_USER_INVITATION_ASSIGN_TO_USER: '/workspace/user_invitation/assign_to_user',

    WORKSPACE_USER_INVITATION_REPLY: '/workspace/user_invitation/reply',

    WORKSPACE_USER_DELETE: '/workspace/user/delete',

    WORKSPACE_USER_USER_CREDITS_LIMIT_UPDATE: '/workspace/user/credits/limit/update',
    WORKSPACE_USER_USER_CREDITS_LIMIT_UPDATE_STATUS: '/workspace/user/credits/limit/update/status',
    WORKSPACE_USER_USER_CREDITS_LIMIT_RESET: '/workspace/user/credits/limit/reset',
  },
  ...ENetworkEventBothWays,
};
